export default {
  barTitle: 'Cookie',
  barDescription: '当サイトでは、サービス改善を目的として当サイト及び第三者が提供するCookieを使用することにより、利用者に当サイトを表示させるとともに、利用者がどのようにサイトを利用しているかをより十分に把握することが可能となっています。このまま閲覧を続けると、Cookieの利用について同意したとみなされます。',
  acceptAll: '全て同意',
  declineAll: '全て削除',
  manageCookies: 'Cookieを管理',
  unsaved: '保存されていない設定があります',
  close: '閉じる',
  save: '保存',
  necessary: '不可欠なCookie',
  optional: '任意のcookies',
  functional: '機能性Cookie',
  blockedIframe: 'ここを表示するには、機能性Cookieを有効にしてください:',
  here: '設定'
}